var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"flex flex-col gap-xs"},[_c('div',{staticClass:"animate-pulse bg-skeleton rounded-md w-cardThumbnailW h-cardThumbnailH"}),_c('TextSkeleton',{staticClass:"h-lg rounded-md",attrs:{"pulse":"","characters":15}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }